import { RouteObject } from 'react-router';

const ticketErsetzenRoutes: RouteObject[] = [
  {
    path: 'ticket-ersetzen',
    children: [
      {
        path: '',
        lazy: () => import('./page/ticket-ersetzen-page.tsx'),
      },
      {
        path: 'lostTicketReturn/:ticketnummer',
        lazy: () => import('../ticket-ersatz/page/lost-ticket-return-page.tsx'),
      },
      {
        path: 'ansicht/:ticketnummer',
        lazy: () => import('../ticket-ersatz/page/lost-ticket-ansicht-page.tsx'),
      },
    ],
  },
];

export default ticketErsetzenRoutes;
